module.exports = __webpack_public_path__ + "img/blog-09-770x420.099eb0a5.jpg";